import React from "react"
import { Sparkles } from "lucide-react"
import type { AssessorFilterTab } from "../types"
import "./AssessorEmpty.style.scss"

interface AssessorEmptyProps {
  filter: AssessorFilterTab
}

const COPY: Record<AssessorFilterTab, { title: string; description: string }> = {
  all: {
    title: "No AI assessments yet",
    description:
      "Submit a question attempt or complete a practice paper. In-progress marking shows here as awaiting feedback.",
  },
  questions: {
    title: "No question assessments yet",
    description:
      "Open a question in the library, write an answer, and submit it for AI marking.",
  },
  papers: {
    title: "No paper assessments yet",
    description:
      "Generate and complete a practice paper to see your paper-level AI feedback.",
  },
}

const AssessorEmpty = ({ filter }: AssessorEmptyProps) => {
  const copy = COPY[filter]
  return (
    <div className="assessor-empty">
      <div className="assessor-empty__icon">
        <Sparkles size={32} />
      </div>
      <h3>{copy.title}</h3>
      <p>{copy.description}</p>
    </div>
  )
}

export default AssessorEmpty
